let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eerRZ")).then(() => parcelRequire('fEXp4'));